export const convertDateFromDatePicker = (from, to) => {
  if (from || to) {
    return IsoDate(from) + '_' + IsoDate(to);
  }
  return '';
};

function IsoDate(time) {
  if (!time) return '';

  const d = new Date(time);

  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
}

export function timeAgo(inputDate) {
  const cleanedDate = inputDate.replace(/\.\d{3}Z$/, '');
  const pastDate = new Date(cleanedDate + 'Z').getTime();
  const now = new Date().getTime();
  const differenceInSeconds = Math.floor((now - pastDate) / 1000);
  if (differenceInSeconds < 60) {
    return 'لحظاتی پیش';
  } else if (differenceInSeconds < 3600) {
    const minutes = Math.floor(differenceInSeconds / 60);
    return `${minutes} دقیقه پیش`;
  } else if (differenceInSeconds < 86400) {
    const hours = Math.floor(differenceInSeconds / 3600);
    return `${hours} ساعت پیش`;
  } else if (differenceInSeconds < 2592000) {
    const days = Math.floor(differenceInSeconds / 86400);
    return `${days} روز پیش`;
  } else if (differenceInSeconds < 31536000) {
    const months = Math.floor(differenceInSeconds / 2592000);
    return `${months} ماه پیش`;
  } else {
    const years = Math.floor(differenceInSeconds / 31536000);
    return `${years} سال پیش`;
  }
}

export const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (cookieName) => {
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  // accessToken
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
};

export const deleteAllCookies = () => {
  let cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf('=');
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
  }
};

export const convertNumberToPrice = (number) => {
  if (!number) return '';
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const isEmptyObject = (values) => {
  const obj = { ...values };
  for (const key in obj) {
    if (!obj[key] || obj[key] == undefined || !obj[key].length) {
      delete obj[key];
    }
  }
  return Object.keys(obj || {}).length ? true : false;
};

export const patternTelInput = (e) => {
  const input = e.target.value;
  const converted = convertNumberPersianToEnglish(input).replace(/[^0-9]/g, '');
  e.target.value = converted;
};

export const queryParams = (filter) => {
  const filteredParams = Object.fromEntries(
    Object.entries(filter).filter(
      ([_, value]) => value !== undefined && value !== null && value !== '' && value.length !== 0,
    ),
  );
  const queryString = new URLSearchParams(filteredParams).toString();
  return queryString;
};

export const removePropertyEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key] === '' || obj[key] == undefined) {
      delete obj[key];
    }
  }
  return obj;
};

export const removePropertyEmptyRequirement = (obj) => {
  for (const key in obj) {
    const value = obj[key];

    // اگر مقدار یک آبجکت یا آرایه است
    if (typeof value === 'object' && value !== null) {
      if (Array.isArray(value)) {
        // حذف عناصر خالی از آرایه
        obj[key] = value
          .map(removePropertyEmptyRequirement)
          .filter(
            (item) => (typeof item === 'object' ? Object.keys(item).length > 0 : item !== null) && item !== undefined,
          );

        // حذف آرایه خالی
        if (obj[key].length === 0) {
          delete obj[key];
        }
      } else {
        // حذف آبجکت‌های خالی
        obj[key] = removePropertyEmptyRequirement(value);
        if (Object.keys(obj[key]).length === 0) {
          delete obj[key];
        }
      }
    } else if (value === '' || value === undefined || value === null) {
      // حذف مقادیر خالی
      delete obj[key];
    }
  }

  return obj;
};

export const convertNumberPersianToEnglish = (input) => {
  const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
  const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  let convertedInput = input;
  for (let i = 0; i < persianNumbers.length; i++) {
    convertedInput = convertedInput.replace(persianNumbers[i], englishNumbers[i]);
  }
  return convertedInput;
};

export const validateNationalID = (melliCode) => {
  const identicalDigits = [
    '0000000000',
    '1111111111',
    '2222222222',
    '3333333333',
    '4444444444',
    '5555555555',
    '6666666666',
    '7777777777',
    '8888888888',
    '9999999999',
  ];

  if (melliCode.trim() === '') {
    return false; // National Code is empty
  } else if (melliCode.length !== 10) {
    return false; // National Code is less or more than 10 digits
  } else if (identicalDigits.includes(melliCode)) {
    return false; // Fake National Code
  } else {
    let sum = 0;

    for (let i = 0; i < 9; i++) {
      sum += parseInt(melliCode.charAt(i)) * (10 - i);
    }

    let lastDigit;
    let divideRemaining = sum % 11;

    if (divideRemaining < 2) {
      lastDigit = divideRemaining;
    } else {
      lastDigit = 11 - divideRemaining;
    }

    if (parseInt(melliCode.charAt(9)) === lastDigit) {
      return true;
    } else {
      return false; // Invalid MelliCode
    }
  }
};

export const isMobileFunc = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 640;
  }
  return false;
};

export const cutPrice = (num) => {
  if (num >= 1000000000000000) {
    return `${parseFloat((num / 1000000000000000).toFixed(1))} هزار تیلیارد`;
  }
  if (num >= 1000000000000) {
    return `${parseFloat((num / 1000000000000).toFixed(1))} تیلیارد`;
  }
  if (num >= 1000000000) {
    return `${parseFloat((num / 1000000000).toFixed(1))} میلیارد`;
  }
  if (num >= 1000000) {
    return `${parseFloat((num / 1000000).toFixed(1))} میلیون`;
  }
  if (num >= 1000) {
    return `${parseFloat((num / 1000).toFixed(1))} هزار`;
  }
  return `${num}`;
};

export const encryptionRandom = () => {
  const result = Math.floor(10000 + Math.random() * 90000);
  return result;
};
